
export enum STATES {
    CONNECTING = "CONNECTING",
    LOOK = "LOOK",
    WAIT_FOR_REQUEST = "WAIT_FOR_REQUEST",
    CONFIRM = "CONFIRM",
    WAITING_FOR_OPPONENT = "WAITING_FOR_OPPONENT",
    SEND_START_GAME = "SEND_START_GAME",
    START_GAME = "START_GAME",
}

interface Matchmaking {
    state: STATES;
    opponentId: string;
    channelId: string;
}

export default Matchmaking;
